import styles from "./month-range-picker.module.scss";
import type { MonthRangePickerPanelView } from "./types-month-range-picker";
import { MonthRangePickerYear } from "./view-year";

/** Corpo do painel: os dois anos lado a lado e a mensagem de intervalo inválido. */
export function MonthRangePickerPanel({
  years,
  error,
  panelTestId,
  errorTestId,
  onPanelLeave,
}: MonthRangePickerPanelView) {
  return (
    <div className={styles.body} onMouseLeave={onPanelLeave} data-testid={panelTestId}>
      <div className={styles.years}>
        {years.map((year) => (
          <MonthRangePickerYear key={year.year} {...year} />
        ))}
      </div>
      {error ? (
        <p className={styles.error} role="alert" data-testid={errorTestId}>
          {error}
        </p>
      ) : null}
    </div>
  );
}
